/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Messages_RecentInputs */

const en_messages_recent = /** @type {(inputs: Messages_RecentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Scheduled & recent (${i?.count} pending)`)
};

const he_messages_recent = /** @type {(inputs: Messages_RecentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`מתוזמנות ואחרונות (${i?.count} ממתינות)`)
};

/**
* | output |
* | --- |
* | "Scheduled & recent ({count} pending)" |
*
* @param {Messages_RecentInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const messages_recent = /** @type {((inputs: Messages_RecentInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_RecentInputs, { locale?: "en" | "he" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_recent(inputs)
	return he_messages_recent(inputs)
});